import React from 'react';
import clsx from 'clsx';
import { StepperTextBlock } from '@marriott/mi-ui-library';
import { RoomsStepperProps } from './RoomsStepper.types';
import { MAX_ROOMS, MIN_ROOMS } from '../../constants';

export const RoomsStepper = ({
  labels,
  value,
  onIncrement,
  onDecrement,
  onInputChange,
  fieldError,
}: RoomsStepperProps) => {
  return (
    <div className="stepper-section">
      <div className={clsx(fieldError && 'stepper-error')}>
        <StepperTextBlock
          copyText={labels.rooms}
          stepperValue={value}
          handleIncrement={onIncrement}
          handleDecrement={onDecrement}
          disableIncrement={value === MAX_ROOMS}
          disableDecrement={value === MIN_ROOMS}
          increamentLabel={`Increase ${labels.label}`}
          decreamentLabel={`Decrease ${labels.label}`}
          variation={'bordered'}
          isInputEditable={true}
          ariaLabel={labels.label}
          onInputChange={onInputChange}
        />
      </div>
      {fieldError ? <p className="stepper-error-text">{fieldError}</p> : null}
    </div>
  );
};
